import type { FlightCardData } from '@massilia/queries'

/**
 * Identité d'une offre dans une liste de résultats — clé React, et rien d'autre.
 *
 * `offerId` est le `xId` du fournisseur : il n'est unique QUE dans sa transaction.
 * En réunissant deux transactions, le multiplexage bagage a rendu les collisions
 * courantes (deux offres sur douze, sur un Paris↔RUN ordinaire), et React, voyant
 * deux enfants porter la même clé, réutilisait les mauvais nœuds : la liste ne
 * suivait plus les filtres — le compteur annonçait 6 vols pendant que 8 cartes
 * restaient à l'écran, l'écart grandissant à chaque changement de filtre.
 *
 * La paire (transaction, offre) est unique : deux offres d'une même transaction
 * ont des `xId` distincts, et deux transactions distinctes sont préfixées
 * différemment. Même forme que la clé de `/vols-multi/resultats`, où la fusion des
 * réponses du chatbot posait déjà exactement ce problème.
 */
export function offerCardKey(offer: FlightCardData, fallbackTransactionKey: string): string {
  return `${offerTransactionKey(offer, fallbackTransactionKey)}__${offer.offerId}`
}

/**
 * Transaction Affidium à laquelle une offre appartient.
 *
 * Une réponse de recherche réunit DEUX appels fournisseur (multiplexage bagage) :
 * `SearchFlightsResponse.transactionKey` ne vaut donc que pour une partie des
 * offres, et c'est `sourceTransactionKey`, posé offre par offre, qui fait foi. Le
 * repli couvre les réponses servies avant le déploiement du multiplexage.
 */
export function offerTransactionKey(offer: FlightCardData, fallback: string): string {
  return offer.sourceTransactionKey ?? fallback
}
